import { render, staticRenderFns } from "./LoginFacebook.vue?vue&type=template&id=6fb25a39&scoped=true"
import script from "./LoginFacebook.vue?vue&type=script&lang=js"
export * from "./LoginFacebook.vue?vue&type=script&lang=js"
import style0 from "./LoginFacebook.vue?vue&type=style&index=0&id=6fb25a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb25a39",
  null
  
)

export default component.exports